import React from 'react';
import { NavMetricPublisher } from 'src/commons/utils/metrics';
import { logWithTakt } from 'src/commons/utils/logWithTakt';
import {
  Cohort,
  publishCohortCounter,
  cohortDetail,
} from 'src/commons/utils/whaleCohort';

export const NavCohortContext = React.createContext<Cohort | undefined>(
  undefined,
);

export const publishNavLinkClick = (
  id: string,
  cohort: Cohort | undefined,
): void => {
  publishCohortCounter(NavMetricPublisher, 'NavLinkClicked', cohort);
  logWithTakt('aac-chrome-global-navigation-click', {
    id,
    ...cohortDetail(cohort),
  });
};
